const selectDeviceTypes = state => state.data.deviceTypes

const DeviceTypeDataStoreSelectors = {
  deviceTypes: selectDeviceTypes
}

export default DeviceTypeDataStoreSelectors
